import React, { useState, useEffect } from 'react';
import { RCTooltip } from '@rmwc/rc-tooltip';
import '@rmwc/rc-tooltip/styles';
import { Snackbar } from '@rmwc/snackbar';
import '@rmwc/snackbar/styles';
import Popup from 'reactjs-popup';
import parse from 'html-react-parser';
import ControlledPopup from './Popup';
import { queue } from './myQueue';
import './Sidebar.css';
import { getText } from './Helpers';
import { useFlexionStore } from './Stores';

import Print from './assets/baseline_print_white_24dp.png';
import Mail from './assets/baseline_email_white_24dp.png';
import Dummy from './assets/kreis-weiß-weiß.png';
import ArrowRight from './assets/baseline_keyboard_arrow_right_white_24dp.png';
import ArrowLeft from './assets/baseline_keyboard_arrow_left_white_24dp.png';
import Exclamation from './assets/baseline_error_outline_white_18dp.png';
import ImpExp from './assets/baseline_import_export_white_24dp.png';
import SuccImg from './assets/baseline_check_white_48dp.png';
import ImpExpPopup from './ImpExpPopup';

export default function Sidebar(props) {
  const Sprache = useFlexionStore((state) => state.Sprache);
  const [open, setOpen] = useState(false);
  const [popopen, setPopopen] = useState(false);
  const [HelpOpen, setHelpOpen] = useState(false);
  const [ImpExpOpen, setImpExpOpen] = useState(false);
  const [openSuccSnack, setOpenSuccSnack] = useState(false);
  const [text, setText] = useState(getText(Sprache));

  useEffect(() => {
    setText(getText(Sprache));
  }, [Sprache]);

  function printTitle() {
    queue.prompt({ inputProps: { outlined: true }, title: 'Titel' }).then((res) => {
      props.Print(res);
    });
  }

  function mail() {
    const win = window.open(
      'mailto:anwendungssoftware-support@rk-online.de?subject=Flexion Ticket'
    );
    if (win && win.open && !win.closed) win.close();
  }

  return (
    <div className={open ? 'Sidebar SidebarOpened' : 'Sidebar SidebarClosed'}>
      <div className='SidebarItem'>
        <RCTooltip
          align='topLeft'
          content={
            <div style={{ fontSize: '1.3em' }}>{text.Sidebar ? text.Sidebar.Print : ''}</div>
          }
        >
          <img src={Print} alt='Drucken' onClick={printTitle} />
        </RCTooltip>
      </div>
      <div className='SidebarItem'>
        <RCTooltip
          align='topLeft'
          content={
            <div style={{ fontSize: '1.3em' }}>{text.Sidebar ? text.Sidebar.Feedback : ''}</div>
          }
        >
          <img src={Mail} alt='Mail' onClick={mail} />
        </RCTooltip>
      </div>
      <div className='SidebarItem'>
        <RCTooltip
          align='topLeft'
          content={
            <div style={{ fontSize: '1.3em' }}>{text.Sidebar ? text.Sidebar.Dummy : ''}</div>
          }
        >
          <img src={Dummy} alt='Dummy' onClick={() => setPopopen(true)} />
        </RCTooltip>
      </div>
      <div className='SidebarItem'>
        <RCTooltip
          align='topLeft'
          content={
            <div style={{ fontSize: '1.3em' }}>{text.Sidebar ? text.Sidebar.ModalTitle : ''}</div>
          }
        >
          <img src={Exclamation} alt='RK Website' onClick={() => setHelpOpen(true)} />
        </RCTooltip>
      </div>
      <div className='SidebarItem'>
        <RCTooltip
          align='topLeft'
          content={
            <div style={{ fontSize: '1.3em' }}>{text.Sidebar ? text.Sidebar.ImportExport : ''}</div>
          }
        >
          <img src={ImpExp} alt='Import/Export' onClick={() => setImpExpOpen(true)} />
        </RCTooltip>
      </div>
      <div className='SidebarOpenClose'>
        <img src={open ? ArrowLeft : ArrowRight} alt='Arrow Right' onClick={() => setOpen(!open)} />
      </div>
      <ControlledPopup open={popopen} closepop={() => setPopopen(false)} />
      <Popup open={HelpOpen} closeOnDocumentClick onClose={() => setHelpOpen(false)}>
        <div className='HelpModal'>
          <h2>{text.Sidebar ? text.Sidebar.ModalTitle : ''}</h2>
          <p>{text.Sidebar ? text.Sidebar.QuickDesc : ''}</p>
          {text.Sidebar ? parse(text.Sidebar.Warn) : ''}
        </div>
      </Popup>
      <Popup open={ImpExpOpen} closeOnDocumentClick onClose={() => setImpExpOpen(false)}>
        <div className='HelpModal'>
          <ImpExpPopup
            closePopupAfterSuccess={() => {
              setImpExpOpen(false);
              setOpenSuccSnack(true);
            }}
          />
        </div>
      </Popup>

      <Snackbar
        open={openSuccSnack}
        onClose={() => setOpenSuccSnack(false)}
        message={text.Sidebar ? text.Sidebar.ImportSuccess : ''}
        icon={SuccImg}
      />
    </div>
  );
}
